import React from 'react';
import { motion } from 'framer-motion';

const CharacterCounter = ({ current, limit, showWarning = true }) => {
    const percentage = limit > 0 ? (current / limit) * 100 : 0;
    const remaining = limit - current;
    const isOverLimit = current > limit;
    const isWarning = percentage >= 80 && percentage < 100;

    // Determine color based on status
    const getColor = () => {
        if (isOverLimit) return 'text-red-600 dark:text-red-400';
        if (isWarning) return 'text-yellow-600 dark:text-yellow-400';
        return 'text-slate-500 dark:text-slate-400';
    };

    const getBarColor = () => {
        if (isOverLimit) return 'bg-red-500';
        if (isWarning) return 'bg-yellow-500';
        return 'bg-yellow-500';
    };

    const getBackgroundColor = () => {
        if (isOverLimit) return 'bg-red-100 dark:bg-red-900/30';
        if (isWarning) return 'bg-yellow-100 dark:bg-yellow-900/30';
        return 'bg-slate-100 dark:bg-slate-800';
    };

    return (
        <div className="flex items-center gap-3">
            {/* Progress bar */}
            <div className={`flex-1 h-1.5 rounded-full ${getBackgroundColor()} overflow-hidden`}>
                <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${Math.min(percentage, 100)}%` }}
                    className={`h-full rounded-full ${getBarColor()}`}
                    transition={{ duration: 0.2 }}
                />
            </div>

            {/* Character count */}
            <span className={`text-sm font-medium tabular-nums ${getColor()}`}>
                {current.toLocaleString()} / {limit.toLocaleString()}
            </span>

            {/* Warning/Error indicator */}
            {showWarning && isOverLimit && (
                <span className="text-xs font-medium text-red-600 dark:text-red-400">
                    {Math.abs(remaining).toLocaleString()} over
                </span>
            )}
        </div>
    );
};

export default CharacterCounter;
